// Sample age bracket definitions matching the config
const ageBrackets = [
  { min: 0, max: 29, rate: 15 },
  { min: 30, max: 39, rate: 20 },
  { min: 40, max: 49, rate: 25 },
  { min: 50, max: 54, rate: 30 },
  { min: 55, max: 59, rate: 35 },
  { min: 60, max: Infinity, rate: 40 }
];

// Add helper function for formatting numbers with commas
function formatNumberWithCommas(num) {
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function calculate(answers) {
  const items = [];
  const grossIncome = Number(answers.grossIncome) || 0;
  const age = Number(answers.age) || 0;
  
  // Find matching age bracket
  const bracket = ageBrackets.find(b => age >= b.min && age <= b.max);
  if (!bracket) {
    return {
      status: "Error",
      items,
      message: `No matching age bracket for age ${age}.`,
      color: "red",
      title: "Calculation Error"
    };
  }
  
  // Calculate maximum contribution as a percentage of gross income.
  const maxContribution = grossIncome * (bracket.rate / 100);

  // Determine tax relief rate based on grossIncome
  let taxReliefRate;
  if (grossIncome <= 40000) {
    taxReliefRate = 0.2;
  } else if (grossIncome <= 50000) {
    taxReliefRate = 0.32;
  } else {
    taxReliefRate = 0.4;
  }

  const taxRelief = maxContribution * taxReliefRate;
  const netContribution = maxContribution - taxRelief;

  // Format numbers with commas
  const formattedMaxContribution = formatNumberWithCommas(maxContribution);
  const formattedTaxRelief = formatNumberWithCommas(taxRelief);
  const formattedNetContribution = formatNumberWithCommas(netContribution);

  // Push JSX items to the items array
  items.push(<span><strong>Contribution Limit:</strong> {bracket.rate}%</span>);
  items.push(<span><strong>Tax Relief:</strong> €{formattedTaxRelief}</span>);
  items.push(<span><strong>Net Contribution:</strong> €{formattedNetContribution}</span>);

  const status = `€${formattedMaxContribution}`;
  const message = "";
  const color = "#038080";
  const title = "Annual Maximum Contribution";

  // Add two JSX items to the result
  return { 
    status, 
    items, 
    message, 
    color, 
    title
  };
}
